import { useClinic } from "../context/ClinicContext";
import { canAccess, effectiveAccess } from "./policy";
export function useAccess() {
  const context = useClinic(),
    member = context?.currentUser;
  return {
    member,
    access: effectiveAccess(member),
    can: (module, action = "read") => canAccess(member, module, action),
  };
}
